import { render, staticRenderFns } from "./contextmousemenucom.vue?vue&type=template&id=48774d02&scoped=true"
import script from "./contextmousemenucom.vue?vue&type=script&lang=js"
export * from "./contextmousemenucom.vue?vue&type=script&lang=js"
import style0 from "./contextmousemenucom.vue?vue&type=style&index=0&id=48774d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48774d02",
  null
  
)

export default component.exports